module.exports = __webpack_public_path__ + "img/012.bfc7b447.png";